import { ThemeProvider } from "@repo/ui/provider";
import { Route, Routes, Navigate } from "react-router";
import { AccessGate } from "@components/AccessGate";
import { OnsiteLayout } from "@layouts/OnsiteLayout";
import { LandingPage } from "@pages/LandingPage";
import { SlidesPage } from "@pages/SlidesPage";
import { ParkingLotPage } from "@pages/ParkingLotPage";
import { FAQPage } from "@pages/FAQPage";
import { AccessDeniedPage } from "@pages/AccessDeniedPage";

function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route element={<AccessGate />}>
          <Route path=":customer/onsite" element={<OnsiteLayout />}>
            <Route index element={<LandingPage />} />
            <Route path="slides" element={<SlidesPage />} />
            <Route path="parking" element={<ParkingLotPage />} />
            <Route path="faq" element={<FAQPage />} />
          </Route>
        </Route>
        <Route path="/" element={<Navigate to="/jlr/onsite" replace />} />
        <Route path="*" element={<AccessDeniedPage />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
